import React from "react"
import scrollIntoView from 'scroll-into-view';
import { _getLocalizedText } from '../../core/utils'

const BackToTop = () => {
	
	const _click = () => {
		// if (window) {
		// 	window.scrollTo(0, 0)
		// }
		// scrollIntoView(document.querySelector("header"), {
		scrollIntoView(document.querySelector("#___gatsby"), {
			// debug: true
		})
	}

	return (
		<button className="back-to-top curp has-icon arrow-n" onClick={_click}>
			{_getLocalizedText('backTop')}
		</button>
	)
}


export default BackToTop
